import { TENANTS } from "../../../constants"
import { LOCAL_STORAGE_TUNNEL_DATA_KEY } from "../../../core/service/BusinessLogicService"
import { getScoreAMLAlertCodesByOpl } from "../../../service/OrderService"
import { useQuery } from "react-query"
import { useLocalStorage } from "react-use"

export default function useGetScoreAMLAlertCodeByOpl(opl) {
  const [localTunnelData] = useLocalStorage(LOCAL_STORAGE_TUNNEL_DATA_KEY)

  const { data: scoreAMLAlertCodes } = useQuery({
    queryKey: ["query-score-aml-alert-codes", opl + "-alert-codes"],
    queryFn: () => getScoreAMLAlertCodesByOpl(localTunnelData, opl),
    retry: false,
    refetchOnWindowFocus: false,
    enabled: !!opl && localTunnelData.tenant === TENANTS.SAMSUNG_ES
  })
  return { scoreAMLAlertCodes }
}
